import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip arrow {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[4],
  },
  [`& .${tooltipClasses.arrow}`]: {
    fontSize: 24,
    color: theme.palette.common.white,
    '&:before': {
      boxShadow: theme.shadows[1],
    },
  },
}));

export function Info({
  title,
  placement,
  children = <InfoOutlinedIcon fontSize="small" sx={{ ml: 1, color: 'action.active' }} />,
}: {
  title: string;
  placement?: TooltipProps['placement'];
  children?: React.ReactElement & React.ReactNode;
}) {
  return (
    <LightTooltip
      placement={placement}
      title={
        title ? (
          <Typography component="p" variant="caption" fontSize={10} fontWeight={500} lineHeight="14px">
            {title}
          </Typography>
        ) : (
          ''
        )
      }
    >
      {children}
    </LightTooltip>
  );
}
